import { type ChatPosition } from '@/app/appStore';

export const BASE_GRID_COLS = 12;
const SIDE_FREE_BONUS_COLS = 4;
const FULL_WIDTH_GRID_COLS = BASE_GRID_COLS + SIDE_FREE_BONUS_COLS * 2;

type GridPrefs = {
  leftNavCollapsed: boolean;
  chatCollapsed: boolean;
  chatPosition: ChatPosition;
};

export function getWorkspaceGridCols(prefs?: GridPrefs): number {
  void prefs;
  return FULL_WIDTH_GRID_COLS;
}

function clampLayout(
  layout: { x: number; y: number; w: number; h: number },
  cols: number,
): { x: number; y: number; w: number; h: number } {
  const w = Math.max(1, Math.min(cols, Math.floor(layout.w)));
  const h = Math.max(1, Math.floor(layout.h));
  const x = Math.max(0, Math.min(cols - w, Math.floor(layout.x)));
  const y = Math.max(0, Math.floor(layout.y));
  return { x, y, w, h };
}

function scaleUnit(value: number, fromCols: number, toCols: number, min = 0): number {
  const scaled = Math.round((value * toCols) / fromCols);
  return Math.max(min, scaled);
}

export function scaleLayoutCols(
  layout: { x: number; y: number; w: number; h: number },
  fromCols: number,
  toCols: number,
): { x: number; y: number; w: number; h: number } {
  if (fromCols === toCols) return clampLayout(layout, toCols);
  return clampLayout(
    {
      x: scaleUnit(layout.x, fromCols, toCols, 0),
      y: layout.y,
      w: scaleUnit(layout.w, fromCols, toCols, 1),
      h: layout.h,
    },
    toCols,
  );
}
